import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import axiosInstance from '@/lib/axios-instance';
import showToast from '@/lib/helpers/show-toast';
import { API_ROUTES } from '@/lib/routes/api-routes';

const signInUser = async () => {
  const { data } = await axiosInstance.get(API_ROUTES.auth.login);

  return data;
};

const showSignInErrorToast = (title: string) => {
  showToast({
    variant: 'error',
    title,
  });
};

const handleSignInError = (error: unknown, t: ReturnType<typeof useTranslation>['t']) => {
  if (isAxiosError(error)) {
    const status = error.response?.status;

    if (status === 429) {
      showSignInErrorToast(t('common:errors.auth.rateLimit'));
    } else if (status === 503 || !error.response) {
      showSignInErrorToast(t('common:errors.auth.serverUnavailable'));
    } else {
      showSignInErrorToast(t('common:errors.auth.unexpected'));
    }
  } else {
    showSignInErrorToast(t('common:errors.auth.network'));
  }
};

const useSignIn = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: signInUser,

    onSuccess: ({ backendAuthenticationUrl }) => {
      if (backendAuthenticationUrl) {
        window.location.href = backendAuthenticationUrl;
      } else {
        showSignInErrorToast(t('common:errors.auth.noRedirect'));
      }
    },

    onError: (error) => {
      handleSignInError(error, t);
    },
  });
};

export default useSignIn;
